module.exports = __webpack_public_path__ + "img/workspace-selection.8eec4ca8.png";